import React from "react";
import type { MenuItemProps as UIMenuItemProps } from "@material-ui/core";
import { MenuItem as UIMenuItem, ListItemText } from "@material-ui/core";
import type { ListItemIconProps } from "../List";
import { ListItemIcon } from "../List";

type MenuItemWithIconProps = UIMenuItemProps & ListItemIconProps;

export const MenuItemWithIcon = React.forwardRef((props: MenuItemWithIconProps, ref: React.Ref<HTMLLIElement>) => {
    const { icon, button, children, ...menuItemProps } = props;
    const renderAsButton = button || (!!props.onClick && button !== false);
    return (
        <UIMenuItem {...menuItemProps} button={renderAsButton as any} ref={ref}>
            <ListItemIcon icon={icon} />
            <ListItemText>{children}</ListItemText>
        </UIMenuItem>
    );
});
